export const useNumberMask = () => (input: string, maxLength = 20): string => {
  if (input === undefined || input === null) {
    return '';
  }
  const inputString = input?.toString();
  const inputValueToDigits = (input: string) => {
    return input?.replace(/\D/g, '');
  };
  const inputNumbers = inputValueToDigits(inputString);

  let formattedInput = '';

  if (inputNumbers.length > 0) {
    formattedInput += `${inputNumbers.substring(0, maxLength)}`;
  }

  return formattedInput;
};
